/**
 * 用户模块
 * http://apimanage.fw:8001/#/home/project/inside/api/list?groupID=67&projectName=%E5%87%A1%E9%97%BB%E8%B5%84%E8%AE%AF%E9%80%9A%E7%94%A8&projectID=25
 * 2018-11-15 wmm
 */

import fetch from '../utils/fetch'
import qs from 'qs'

const USERURL = window.SERVERAPI.API_USER

/**
 * 项目配置
 * 2018-11-15
 */

// 新建自定义页面
export function addPageCustom(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/Add',
    method: 'post',
    data
  })
}
// 新建页面 根据部门id
export function getModulesConfig(params) {
  let { did } = params
  if (did) {
    return getDidModulesConfig(params)
  } else {
    return getCurrentModulesConfig(params)
  }
}
// 新建页面 根据部门id
export function getDidModulesConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/getbydid',
    method: 'get',
    params
  })
}
// 新建页面 根据部门id
export function getUidModulesConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/getbyuid',
    method: 'get',
    params
  })
}
// 新建页面 根据部门id
export function getCurrentModulesConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/getcurrentuserpage',
    method: 'get',
    params
  })
}
// 编辑自定义页面
export function editPageCustom(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/edit',
    method: 'post',
    data
  })
}
// 新建自定义页面
export function savePageConfig(data) {
  let { id } = data
  if (id) {
    return editPageCustom(data)
  } else {
    return addPageCustom(data)
  }
}
// 新建自定义页面
export function saveProjectConfig(data) {
  let { id } = data
  if (id) {
    return editProjectConfig(data)
  } else {
    return addProjectConfig(data)
  }
}
// 获取当前用户配置
export function getUserConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/GetCurrentUserConfig',
    method: 'get',
    params
  })
}

// 根据项目简拼获取配置
export function getProjectConfig(data) {
  let { sid } = data
  if (sid) {
    return getSidProjectConfig(data)
  } else {
    return getCurrentProjectConfig(data)
  }
}
// 根据项目简拼获取配置
export function getSidProjectConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/getbysid',
    method: 'get',
    params
  })
}
// 根据项目简拼获取登录配置
export function getLoginModule(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/PageCustom/GetLoginPage',
    method: 'get',
    params
  })
}

// 列表
export function getProjectList(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/GetSearch',
    method: 'get',
    params
  })
}
/**
 * 获取配置，根据部门Id
 * @export
 * @param { object } params
 * did [number] 部门id
 * @returns
 */
export function getDidProjectConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/getbydid',
    method: 'get',
    params
  })
}
export function getCurrentProjectConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/GetCurrentPersionConfig',
    method: 'get',
    params
  })
}
/**
 * 获取配置，根据项目配置id
 * @export
 * @param { object } data { id: 项目配置id}
 * @returns
 */
export function getIdProjectConfig(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/get',
    method: 'get',
    params
  })
}
/**
 * 新建项目
 * @export
 * @param { object } data
 * projectName [string] 项目名称
 * simpleName [string] 项目简拼
 * departId [int] 部门Id
 * backgroundImage [string] 背景图
 * logoImage [string] logo
 * loginUrl [string] 登录地址
 * projectFlag [string] 项目标识：1正式，2临时，默认2
 * serviceType [string] 服务类型：1媒体，2政府，3企业默认1
 * buyType [string] 购买类型 1标准，2专业，3高级，4完整，默认1
 * showFooter [string] 显示版本信息，技术支持等信息
 * expiredTime [string] 过期时间
 * skinStyle [string] 皮肤
 * @returns
 */
export function addProjectConfig(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/Add',
    method: 'post',
    data
  })
}
/**
 * 编辑项目
 * @returns
 */
export function editProjectConfig(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/edit',
    method: 'post',
    data
  })
}
/**
 * 删除项目
 * @returns
 */
export function deleteProjectConfig(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ProjectConfig/Delete',
    method: 'post',
    data
  })
}

/**
 * 组件新增
 * @returns
 */
export function setComponent(data) {
  let { id } = data
  if (id) {
    return editComponent(data)
  } else {
    return addComponent(data)
  }
}
/**
 * 组件新增
 * @returns
 */
export function addComponent(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ComponentResource/Add',
    method: 'post',
    data
  })
}
/**
 * 组件编辑
 * @returns
 */
export function editComponent(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ComponentResource/edit',
    method: 'post',
    data
  })
}
/**
 * 组件删除
 * @returns
 */
export function deleteComponent(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ComponentResource/Delete',
    method: 'post',
    data
  })
}
/**
 * 组件列表
 * @returns
 */
export function getComponents(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/ComponentResource/getlist',
    method: 'get',
    params
  })
}

// sso登录
export function login(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Login',
    method: 'get',
    params
  })
}

// 登录
export function authToken(data) {
  return fetch({
    url: USERURL + '/oauth2/token',
    method: 'post',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}

/**
 * 用户管理
 * 2018-11-15
 */

// 新建用户
export function addUser(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/Add',
    method: 'post',
    data: data
  })
}
// 重置密码
export function changePassword(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/ResetPassword',
    method: 'post',
    data: data
  })
}

// 修改用户
export function editUser(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/Edit',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/Delete',
    method: 'post',
    data
  })
}

// 设置角色
export function setRolesUser(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/SetRoles',
    method: 'post',
    data
  })
}

// 获取用户列表
export function getListUser(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/GetList',
    method: 'get',
    params
  })
}
// 获取用户列表
export function getMultiLevelList(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/GetMultiLevelList',
    method: 'get',
    params
  })
}
// 获取用户信息
export function getUser(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/GetOwner',
    method: 'get',
    params
  })
}
// 更改用户状态
export function setActive(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/SetActive',
    method: 'post',
    data
  })
}
// 更改用户部门
export function setDepartement(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/User/SetDepartment',
    method: 'post',
    data
  })
}

/**
 * 菜单
 * 2018-11-15
 */

// 添加菜单
export function getOwnerMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/GetOwner',
    method: 'get',
    params
  })
}

// 添加菜单
export function addMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/Add',
    method: 'post',
    data
  })
}
// 复制菜单
export function copyMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/Copy',
    method: 'post',
    data
  })
}
// 修改菜单
export function editMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/Edit',
    method: 'post',
    data
  })
}
// 获取菜单
export function getMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/get',
    method: 'get',
    params
  })
}

// 获取菜单使用resourceId和departId
export function getByResourceIdandDepartIdMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/GetByResourceIdandDepartId',
    method: 'get',
    params
  })
}
// 获取菜单
export function getListBySetStatusMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/GetListBySetStatus',
    method: 'get',
    params
  })
}
// 获取组织菜单
export function getListByDepartIdMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/GetListByDepartId',
    method: 'get',
    params
  })
}
// 获取用户在组织里的菜单
export function getListByUserIdMenu(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/GetListByUserId',
    method: 'get',
    params
  })
}
// 设置隐藏
export function setHideMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/SetHide',
    method: 'post',
    data
  })
}
// 设置首页
export function setIndexMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/SetIndex',
    method: 'post',
    data
  })
}
// 设置排序
export function setSortMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/SetSort',
    method: 'post',
    data
  })
}
// 取消首页设置
export function cancelIndexMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/CancelIndex',
    method: 'post',
    data
  })
}

// 取消首页设置
export function deleteMenu(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Menu/Delete',
    method: 'post',
    data
  })
}

/**
 * 部门管理 Department
 * 2018-11-15
 */
// 获取部门列表
export function getListDepartment(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/GetList',
    method: 'get',
    params
  })
}
// 获取部门列表
export function getListByParentId(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/GetListByParentId',
    method: 'get',
    params
  })
}
// 部门详情
export function getDepartment(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/Get',
    method: 'get',
    params
  })
}
// 新建部门
export function addDepartment(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/Add',
    method: 'post',
    data
  })
}
// 修改部门
export function editDepartment(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/Edit',
    method: 'post',
    data: data
  })
}
// 删除部门
export function deleteDepartment(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/Delete',
    method: 'post',
    data
  })
}
// 删除部门
export function getListByHighNodeDepartment(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Department/GetListByHighNode0',
    method: 'get',
    params
  })
}

/**
 * 资源管理 Resource
 * 2018-11-15
 */
// 获取资源api列表
export function getApiListResource(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/GetApiList',
    method: 'get',
    params
  })
}
// 获取资源列表
export function getListResource(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/GetList',
    method: 'get',
    params
  })
}
// 资源详情
export function getResource(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/Get',
    method: 'get',
    params
  })
}
// 新建资源
export function addResource(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/Add',
    method: 'post',
    data
  })
}
// 修改资源
export function editResource(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/Edit',
    method: 'post',
    data
  })
}
// 删除资源
export function deleteResource(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/Delete',
    method: 'post',
    data
  })
}
// 获取类型资源列表
export function getListByTypeResource(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Resource/GetListByType',
    method: 'get',
    params
  })
}

/**
 * 角色管理
 * 2018-11-15
 */
// 角色列表
export function getListRole(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/GetList',
    method: 'get',
    params
  })
}
//  角色详情
export function getRole(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/Get',
    method: 'get',
    params
  })
}
//  新建角色
export function addRole(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/Add',
    method: 'post',
    data
  })
}
//  修改角色
export function editRole(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/edit',
    method: 'post',
    data
  })
}
//  删除角色
export function deleteRole(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/Delete',
    method: 'post',
    data
  })
}
//  获取权限树
export function getResourceTreeRole(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/GetResourceTree',
    method: 'get',
    params
  })
}
//  角色资源权限修改
export function editResourceTreeRole(data) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/EditResourceTree',
    method: 'post',
    data
  })
}
//  角色资源权限修改
export function getListByUserRole(params) {
  return fetch({
    url: USERURL + '/fanews/usermanage/Role/GetListByUser',
    method: 'get',
    params
  })
}
